import { validateCaptionsConfigIntegrity } from 'blocks/TextOverlayModal/v2';
import { PodcastTemplateConfig } from 'redux/middleware/api/podcast-service';
import { getCaptionsFromConfig } from '../modules/captions/utils';
import { CaptionsState } from '../types';

export const getCaptions = (
  config: PodcastTemplateConfig,
): CaptionsState | undefined => {
  if (!config.captions || !validateCaptionsConfigIntegrity(config.captions)) {
    return undefined;
  }

  return getCaptionsFromConfig(config.captions);
};
